import u from "./ui.module.css";

const TONES = {
  gray: u.badgeGray,
  blue: u.badgeBlue,
  green: u.badgeGreen,
  orange: u.badgeOrange,
  red: u.badgeRed,
  purple: u.badgePurple,
};

export default function Badge({ children, tone = "gray", className = "" }) {
  return (
    <span className={`${u.badge} ${TONES[tone] || TONES.gray} ${className}`}>
      {children}
    </span>
  );
}
